
import Vue from 'vue'

export default Vue.extend({
   name: 'PaymentMethodChooseSchool',
   computed: {
      hasSchool(): boolean {
         return !!this.$store.state.purchase.SchoolId
      },
   },
   methods: {
      async chooseSchool() {
         await this.$store.dispatch('setOrderType', false)
         this.$store.commit('setStep', 'information')
      },
   },
})
